import _ from 'lodash';

import { PATH } from '../constants/path';
import { DEFAULT_LOCALE } from '../constants/locale';
import { COIN_NAME, USE_PARITY } from '../constants';

/**
 * Retourne true si l'url est une url extérieur à l'application
 * @param {String url} url
 */
export function isUrlExterieur(url) {
    return url && (_.startsWith(url, 'http') || _.startsWith(url, 'www'));
}

/**
 * Ajoute 'http://' devant une url extérieur avec seulement www au début
 * @param {String} url
 */
export function reformUrlExterieur(url) {
    let retour = url;
    if (isUrlExterieur(url) && _.startsWith(url, 'www')) {
        return 'http://' + url;
    }
    return retour;
}

/**
 * Retourne un tableau avec l'alphabet
 */
export function getAlphabet() {
    return _.range('a'.charCodeAt(0), 'z'.charCodeAt(0) + 1).map(charCode =>
        String.fromCharCode(charCode)
    );
}

/**
 * Retourne un tableau avec 123 en premier et ensuite l'alphabet
 */
export function getAlphabetAnd123() {
    return ['123', ...getAlphabet()];
}

/**
 * Retourne un FormData en fonction d'un json en entrée
 */
export const getFormDataFromJson = object =>
    Object.keys(object).reduce((formData, key) => {
        formData.append(key, object[key]);
        return formData;
    }, new FormData());

/**
 * Retourne l'url vers l'instertitiel coupon
 * TODO à bouger dans la future feature interstitiel. Créer un utils avec toutes les fonctions pour créer des urls d'interstitiems
 */
export function getInstertitielCouponUrl({ idPartenaire, idCoupon }) {
    return idCoupon && idPartenaire
        ? `${PATH.INTERSTITIEL_REDUCTION_PATH}${idPartenaire}/-8/${idCoupon}`
        : '';
}

/**
 * Return pathname with params join with &
 * @param {*String} pathname
 * @param {*Object} params object containing { [param name]: value }
 */
export const addParamsToPathname = (pathname, params = {}) =>
    pathname.concat('?').concat(
        Object.keys(params)
            .reduce((res, curr) => {
                res.push(`${curr}=${params[curr]}`);
                return res;
            }, [])
            .join('&')
    );

export const isNormalInteger = str => {
    return /^\+?(0|[1-9]\d*)$/.test(str);
};

export const formatAmount = str => {
    return (
        str.toLocaleString(navigator.language, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }) + ' €'
    );
};

export const formatAmountCurrency = amount => {
    const hasDecimals = !Number.isInteger(Number(amount));
    return new Intl.NumberFormat('fr-FR', {
        minimumFractionDigits: hasDecimals ? 2 : 0,
        maximumFractionDigits: hasDecimals ? 2 : 0,
        style: 'currency',
        currency: 'EUR'
    }).format(amount);
};

export const formatAmountParity = amount => {
    return `${amount} ${COIN_NAME}`;
};

export const getParityTotal = (total, amountCashback) => {
    if (USE_PARITY) return Math.floor(total / 10) * amountCashback;
};

export const renderConditionalOrNothing = (str, condition) =>
    str && condition && condition() ? str : null;

export const toi18nKey = str => _.toUpper(_.snakeCase(str));

// Scrolls to the top of the page. When embedded in a parent iframe (e.g.
// leboncoin), scrolling the inner window has no visible effect, so we also ask
// the parent to scroll up via postMessage (same shape as the resize reporter).
export const scrollToTop = () => {
    window.scrollTo(0, 0);
    if (window.parent !== window) {
        window.parent.postMessage(
            {
                width: document.body.scrollWidth,
                height: document.body.scrollHeight,
                scrollToTop: true
            },
            '*'
        );
    }
};

// Redirects to the given url. When embedded in a parent iframe (e.g. leboncoin),
// navigating window.location only changes the inner frame; we want the parent
// site to navigate instead. We ask the parent via postMessage (same convention
// as the resize/scroll reporter) and also attempt a direct top-level navigation
// for the same-origin case (cross-origin throws, so it is wrapped in try/catch).
export const redirectParent = url => {
    if (window.parent !== window) {
        window.parent.postMessage({ redirectUrl: url }, '*');
        try {
            window.top.location.href = url;
        } catch (e) {
            // Cross-origin parent: navigation is handled by the parent via the
            // postMessage above.
            console.log('Failed to redirect to ' + url);
        }
    } else {
        window.location.href = url;
    }
};

export const scrollToAnchor = location => {
    const { hash } = location;
    if (hash) {
        setTimeout(() => {
            const id = hash.replace('#', '');
            const element = document.getElementById(id);
            if (element) element.scrollIntoView();
        }, 250);
    }
};

export const addLocaleToPathIfNeeded = ({ locale, to }) => {
    if (isUrlExterieur(to)) {
        return reformUrlExterieur(to);
    } else {
        return `${locale !== DEFAULT_LOCALE ? `/${locale}` : ''}${to}`;
    }
};

export const formatNumber = (number, locale) => number.toLocaleString(locale);

export const getPartnerIdFromQuery = query => _.last(query.split('-'));
export const getPartnerNameFromQuery = query => _.initial(query.split('-')).join('-');



// WEBPACK FOOTER //
// ./src/utils/index.js